import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { configApi } from '../services/api';
import {
  applyCartPromotionBadgeCssVars,
  buildCartPromotionBadgeStyle,
  DEFAULT_CART_PROMOTION_BADGE,
  formatCartPromotionLabel,
} from '../utils/cartPromotionBadge';

const CartPromotionBadgeContext = createContext(null);

export const CartPromotionBadgeProvider = ({ children }) => {
  const [config, setConfig] = useState(DEFAULT_CART_PROMOTION_BADGE);

  useEffect(() => {
    let cancelled = false;

    configApi
      .getCartPromotionBadgeConfig()
      .then((data) => {
        if (cancelled || !data) return;
        const merged = { ...DEFAULT_CART_PROMOTION_BADGE, ...data };
        setConfig(merged);
        applyCartPromotionBadgeCssVars(merged);
      })
      .catch(() => {
        applyCartPromotionBadgeCssVars(DEFAULT_CART_PROMOTION_BADGE);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const value = useMemo(
    () => ({
      config,
      style: buildCartPromotionBadgeStyle(config),
      getLabel: formatCartPromotionLabel,
    }),
    [config],
  );

  return (
    <CartPromotionBadgeContext.Provider value={value}>{children}</CartPromotionBadgeContext.Provider>
  );
};

export const useCartPromotionBadge = () => {
  const ctx = useContext(CartPromotionBadgeContext);
  if (!ctx) {
    return {
      config: DEFAULT_CART_PROMOTION_BADGE,
      style: buildCartPromotionBadgeStyle(DEFAULT_CART_PROMOTION_BADGE),
      getLabel: formatCartPromotionLabel,
    };
  }
  return ctx;
};
